<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('云种植气候.气候名称')">
                <a-input
                  v-model="queryParam.climateName"
                  @pressEnter="handleQuery"
                  :placeholder="$t('通用.输入.请输入') + $t('云种植气候.气候名称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item :label="$t('云种植气候.状态')">-->
<!--                <a-select v-model="queryParam.status" allowClear>-->
<!--                  <a-select-option v-for="(item, index) in customDict.IEnum" :value="item.type" :key="index">-->
<!--                    {{ item.name }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('通用.按钮.查询') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('通用.按钮.重置') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['climate:climate:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['climate:climate:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="coverImage" slot-scope="text, record">
          <img
            v-if="record.coverImage"
            :src="record.coverImage"
            style="width: 60px; height: 60px; object-fit: cover"
            @click="handlePreview(record.coverImage)"
            alt="封面"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="(checked) => handleStatusChange(record, checked)" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['climate:climate:edit']">
            <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['climate:climate:remove']">
            <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="预览" style="width: 100%" :src="previewUrl" />
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageClimate, delClimate, updateClimate } from '@/api/cloudplant/climate'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'

export default {
  name: 'Climate',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      multiple: true,
      loading: false,
      total: 0,
      previewVisible: false,
      previewUrl: '',
      queryParam: {
        climateName: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('云种植气候.气候名称'), dataIndex: 'climateName', ellipsis: true, align: 'center' },
        { title: this.$t('云种植气候.封面图'), dataIndex: 'coverImage', scopedSlots: { customRender: 'coverImage' }, align: 'center', width: 100 },
        { title: this.$t('云种植气候.排序'), dataIndex: 'sort', align: 'center', width: 80 },
        { title: this.$t('云种植气候.状态'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: this.$t('云种植气候.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created() {
    this.getList()
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    getList() {
      this.loading = true
      pageClimate(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { climateName: undefined, status: undefined, pageNum: 1, pageSize: 10 }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.multiple = !selectedRowKeys.length
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    handleStatusChange(record, checked) {
      const status = checked ? 1 : 0
      updateClimate({ id: record.id, status: status }).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.getList()
      })
    },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          if (row.id) {
            data.push({ id: row.id })
          } else {
            that.selectedRowKeys.forEach(id => data.push({ id: id }))
          }
          return delClimate(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'), 3)
          })
        }
      })
    }
  }
}
</script>
